/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as ClipboardButtonDefault } from './clipboard-button-default.story';
export { default as ClipboardButtonNotIconButton } from './clipboard-button-not-icon-button.story';
export { default as ClipboardButtonSizes } from './clipboard-button-sizes.story';
export { default as ClipboardButtonTooltip } from './clipboard-button-tooltip.story';
export { default as ClipboardButtonDisabled } from './clipboard-button-disabled.story';
export { default as ClipboardButtonNotClean } from './clipboard-button-not-clean.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import ClipboardButtonDefaultSrcRaw from './clipboard-button-default.story?raw';
import ClipboardButtonDisabledSrcRaw from './clipboard-button-disabled.story?raw';
import ClipboardButtonNotCleanSrcRaw from './clipboard-button-not-clean.story?raw';
import ClipboardButtonNotIconButtonSrcRaw from './clipboard-button-not-icon-button.story?raw';
import ClipboardButtonSizesSrcRaw from './clipboard-button-sizes.story?raw';
import ClipboardButtonTooltipSrcRaw from './clipboard-button-tooltip.story?raw';

export const ClipboardButtonDefaultSrc = removeLicenseHeader(
  ClipboardButtonDefaultSrcRaw,
);
export const ClipboardButtonNotIconButtonSrc = removeLicenseHeader(
  ClipboardButtonNotIconButtonSrcRaw,
);
export const ClipboardButtonSizesSrc = removeLicenseHeader(
  ClipboardButtonSizesSrcRaw,
);
export const ClipboardButtonTooltipSrc = removeLicenseHeader(
  ClipboardButtonTooltipSrcRaw,
);
export const ClipboardButtonDisabledSrc = removeLicenseHeader(
  ClipboardButtonDisabledSrcRaw,
);
export const ClipboardButtonNotCleanSrc = removeLicenseHeader(
  ClipboardButtonNotCleanSrcRaw,
);
